export const messages = {
  en: {
    staffAppAuthManage: {
      title: 'Authentication Information',
      staffName: 'Staff Name',
      authType: 'Authentication Type',
      authName: 'Authentication Name',
      authId: 'Authentication ID',
      authStatus: 'Authentication Status',
      authTime: 'Authentication Time',
      auth: 'Authenticate',
      fetchError: 'Failed to fetch authentication data'
    },
    addStaffAppAuth: {
      title: 'Start Authentication',
      authType: 'Authentication Type',
      qrcode: 'QR Code',
      scanTip: 'Please scan the QR code with WeChat for authentication',
      finishScan: 'Scan Completed',
      requiredSelect: 'Required, please select authentication type',
      wechat: 'WeChat',
      qrcodeError: 'Failed to generate QR code',
      authSuccess: 'Authentication successful',
      authFail: 'Authentication failed',
      authPending: 'Authentication not completed yet, please finish authentication in WeChat'
    }
  },
  zh: {
    staffAppAuthManage: {
      title: '认证信息',
      staffName: '员工名称',
      authType: '认证方式',
      authName: '认证名称',
      authId: '认证ID',
      authStatus: '认证状态',
      authTime: '认证时间',
      auth: '认证',
      fetchError: '获取认证数据失败'
    },
    addStaffAppAuth: {
      title: '开始认证',
      authType: '认证方式',
      qrcode: '二维码',
      scanTip: '请用微信扫一扫二维码认证',
      finishScan: '扫码完成',
      requiredSelect: '必填，请选择认证方式',
      wechat: '微信',
      qrcodeError: '生成二维码失败',
      authSuccess: '认证成功',
      authFail: '认证失败',
      authPending: '认证尚未完成，请在微信中完成认证后重试'
    }
  },
  'zh-TW': {
    staffAppAuthManage: {
      title: '認證信息',
      staffName: '員工名稱',
      authType: '認證方式',
      authName: '認證名稱',
      authId: '認證ID',
      authStatus: '認證狀態',
      authTime: '認證時間',
      auth: '認證',
      fetchError: '獲取認證數據失敗'
    },
    addStaffAppAuth: {
      title: '開始認證',
      authType: '認證方式',
      qrcode: '二維碼',
      scanTip: '請用微信掃一掃二維碼認證',
      finishScan: '掃碼完成',
      requiredSelect: '必填，請選擇認證方式',
      wechat: '微信',
      qrcodeError: '生成二維碼失敗',
      authSuccess: '認證成功',
      authFail: '認證失敗',
      authPending: '認證尚未完成，請在微信中完成認證後重試'
    }
  }
}